<si-application-header class="app-header">
    <si-header-brand>
        <a
            siHeaderLogo
            [routerLink]="['/main']"
            class="d-none d-md-flex"
            [attr.aria-label]="'header-actions-label-basic-templates' | translate"
        >
            <img [src]="(theme.activeTheme$ | async)?.logo" alt="" />
        </a>
    </si-header-brand>

    <si-header-actions>
        <button class="skip-link" type="button" (click)="focusBasicTemplatesSidenav()">
            {{ 'a11y-skip-to-basic-templates' | translate }}
        </button>

        @if (userProfile$ | async; as user) {
            <app-header-profile [mode]="profileTypes.FULL" [profile]="user"></app-header-profile>
        }
        @if (selectedProfile$ | async; as selected) {
            <button
                type="button"
                class="profile-info"
                (click)="headerProfile?.openDropdown()"
                [attr.aria-label]="'header-actions-label-profile' | translate"
                aria-haspopup="menu"
                [attr.aria-expanded]="headerProfile?.isDropdownOpen ?? false"
            >
                <span class="profile-name">{{ selected.displayName }}</span>
                <span class="profile-department">{{ selected.department }}</span>
            </button>
        }
        <div class="header-divider"></div>
        <div class="dark-mode-toggle">
            <button
                type="button"
                class="si-header-item btn btn-circle btn-ghost dark-mode-btn"
                [attr.aria-label]="
                    (theme.isDarkMode() ? 'header-actions-label-light-mode' : 'header-actions-label-dark-mode')
                        | translate
                "
                (click)="theme.toggleDarkMode()"
            >
                <si-icon [icon]="theme.getDarkModeIcon()" />
            </button>
        </div>
        <app-header-actions></app-header-actions>
    </si-header-actions>
</si-application-header>
